import { Controller } from "@hotwired/stimulus"

const TODO_FORM_CONTROLLER = "aquifer-ui-quiz-results-todo-form"

export default class extends Controller {
  static targets = ["modal", "nameInput", "saveButton"]

  openWithIndex(index, { currentName = "" } = {}) {
    this.activeIndex = index

    if (this.hasNameInputTarget) {
      this.nameInputTarget.value = currentName
      this.syncSaveButton()
    }

    this.modalController()?.show()
    requestAnimationFrame(() => {
      this.nameInputTarget?.focus()
      this.nameInputTarget?.select()
    })
  }

  save(event) {
    event.preventDefault()

    const listName = this.nameInputTarget?.value.trim()
    if (!listName || this.activeIndex == null) return

    this.todoFormController()?.applyNewListName(this.activeIndex, listName)
    this.resetAndClose()
  }

  close(event) {
    event?.preventDefault()
    this.resetAndClose()
  }

  syncSaveButton() {
    if (!this.hasSaveButtonTarget) return

    const hasName = Boolean(this.nameInputTarget?.value.trim())
    this.saveButtonTarget.disabled = !hasName
  }

  handleNameInputKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      if (!this.saveButtonTarget?.disabled) this.save(event)
      return
    }

    if (event.key === "Escape") {
      event.preventDefault()
      this.close()
    }
  }

  resetAndClose() {
    this.activeIndex = null

    if (this.hasNameInputTarget) {
      this.nameInputTarget.value = ""
      this.syncSaveButton()
    }

    this.modalController()?.close()
  }

  todoFormController() {
    const formRoot = document.querySelector(`[data-controller~="${TODO_FORM_CONTROLLER}"]`)
    if (!formRoot) return null

    return this.application.getControllerForElementAndIdentifier(formRoot, TODO_FORM_CONTROLLER)
  }

  modalController() {
    const modalRoot = this.hasModalTarget
      ? this.modalTarget
      : document.getElementById("create-list-modal")

    if (!modalRoot) return null

    return this.application.getControllerForElementAndIdentifier(modalRoot, "railsui-modal")
  }
}
